import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { loginWithPasskey } from "@/lib/passkey";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const out = () => setUser(false);
    window.addEventListener("auth:logout", out);
    return () => window.removeEventListener("auth:logout", out);
  }, [reload]);

  const login = async (phone, password, remember = true) => {
    const { data } = await api.post("/auth/login", { phone, password, remember });
    setUser(data);
    return data;
  };
  const loginPasskey = async (id) => {
    const data = await loginWithPasskey(id);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  };
  const can = (p) => user && (user.role === "admin" || (user.permissions || []).includes(p));

  return <Ctx.Provider value={{ user, login, loginPasskey, logout, reload, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
